<template>
  <v-app class="pwa-layout">
    <div class="pwa-content-wrapper" :class="{ 'no-nav': hideNav }">
      <slot></slot>
    </div>
    
    <!-- 하단 네비게이션 바 (로그인/회원가입 페이지에서는 숨김) -->
    <div v-if="!hideNav" class="pwa-bottom-nav">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="nav-item"
        :class="{ active: isActiveRoute(item.path) }"
      >
        <div class="nav-icon-wrapper">
          <v-icon :size="24" :color="isActiveRoute(item.path) ? item.activeColor : '#9ca3af'">
            {{ item.icon }}
          </v-icon>
        </div>
        <span class="nav-label">{{ item.label }}</span>
      </router-link>
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

// 로그인/회원가입 페이지에서는 하단 네비 숨김
const hideNav = computed(() => {
  const hiddenPaths = ['/pwa/login', '/pwa/signup'];
  return hiddenPaths.includes(route.path);
});

const navItems = [
  {
    path: '/pwa/employees',
    label: '직원',
    icon: 'mdi-account-group',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/payroll',
    label: '급여',
    icon: 'mdi-currency-krw',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/home',
    label: '홈',
    icon: 'mdi-home',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/finance',
    label: '회계',
    icon: 'mdi-cash-multiple',
    activeColor: '#1e3a8a'
  },
  {
    path: '/pwa/settings',
    label: '더보기',
    icon: 'mdi-dots-horizontal',
    activeColor: '#1e3a8a'
  }
];

const isActiveRoute = (path: string): boolean => {
  return route.path === path || route.path.startsWith(path + '/');
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/pwaLayout.scss';
</style>

